import t from 'rcm-i18n';
import React, {Component} from 'react';

interface Props {
    onContinueShopping: () => void;
}

export default class AddToCartSuccessScreen extends Component<Props> {
    public render() {
        return <div>
            <div>{t('This item has been added to your cart.')}</div>
            <br/>
            <div className="clearfix button-container">
                <a className="pull-sm-left btn btn-default"
                        onClick={this.props.onContinueShopping}>
                    {t('Continue Shopping')}
                </a>
                <a className="pull-right btn btn-primary" href="/cart#/items">
                    {t('View Cart')}
                </a>
            </div>
        </div>;
    }
}
